import React from "react";

export default function AdminOrders() {
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Orders</h2>
        <div style={{ color: "#64748b", fontSize: 13 }}>
          Review purchase requests for Products and Banner Items. This section will include filters and approval actions.
        </div>
      </div>

      <div
        style={{
          border: "1px solid #e2e8f0",
          borderRadius: 10,
          overflow: "hidden",
          background: "#fff",
          padding: 16,
          color: "#64748b",
        }}
      >
        Coming soon.
      </div>
    </div>
  );
}

